import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRouteUser = ({ isAuthenticated, element }) => {
  const location = useLocation();

  if (isAuthenticated) {
    return element;
  }

  const redirect = encodeURIComponent(location.pathname + location.search);
  return <Navigate to={`/login?redirect=${redirect}`} replace />;
};

export default ProtectedRouteUser;
